import React from "react";
import Button from "../../Widgets/Button";
import Styles from "../shopList.module.scss";

interface ICartTopButtonsProps {
  isOpen: boolean;
  cartLength: number;
  onConfirmationClick: any;
  lastOrder: IOrders | null;
  addOrderToCart: () => boolean;
}

function CartTopButtons({
  isOpen,
  cartLength,
  onConfirmationClick,
  lastOrder,
  addOrderToCart,
}: ICartTopButtonsProps) {
  return (
    <>
      {cartLength > 0 && isOpen ? (
        <div
          className={Styles.confirmOrder}
          onClick={onConfirmationClick}
          data-component-name="ConfirmOrderButton"
        >
          <Button
            title={"ConfirmOrder"}
            iconClassName={"consumer-right-arrow"}
            className={Styles.confirmOrderBtn}
          />
        </div>
      ) : lastOrder && cartLength === 0 && !isOpen ? (
        <Button
          title={"RepeatOrder"}
          iconClassName={"consumer-buy"}
          dataComponentName="RepeatOrderButton"
          onClick={(e) => {
            const isAllItems = addOrderToCart();
            if (!isAllItems) {
              e.stopPropagation();
            }
          }}
          className={Styles.repeatBtn}
        />
      ) : (
        <Button
          title={"Checkout"}
          className={
            cartLength > 0 ? Styles.checkoutBtn : Styles.emptyCheckoutBtn
          }
          iconClassName={"consumer-buy"}
          dataComponentName="CheckoutButton"
        />
      )}
    </>
  );
}

export default React.memo(CartTopButtons);
